import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface CreateInventoryHeaderProps {
  isEditMode: boolean;
  onBack: () => void;
}

export const CreateInventoryHeader: React.FC<CreateInventoryHeaderProps> = ({ isEditMode, onBack }) => {
  return (
    <div className="flex items-center gap-4">
      <button
        data-test-id="inventory-create-back"
        onClick={onBack}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <ArrowLeft className="w-6 h-6 text-gray-600" />
      </button>
      <h1 className="text-2xl font-semibold text-gray-900">
        {isEditMode ? 'Edit Inventory Item' : 'Create Inventory Item'}
      </h1>
    </div>
  );
};
